import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { ShellActions } from "@opm/ng-core";
import { ProfileService } from "core/services/profile.service";
import { catchError, mergeMap } from "rxjs/operators";
import { Lookups } from "../lookup-state";
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/effects";
import * as i2 from "../../services/profile.service";
import * as i3 from "@ngrx/store";
var LookupEffects = /** @class */ (function () {
    function LookupEffects(actions$, profileService, store) {
        var _this = this;
        this.actions$ = actions$;
        this.profileService = profileService;
        this.store = store;
        this.loadAgencies$ = createEffect(function () { return _this.actions$.pipe(ofType(Lookups.loadAgencies), mergeMap(function (action) { return _this.profileService.getAgencies().pipe(mergeMap(function (response) {
            return [
                Lookups.updateAgencies(response),
            ];
        }), catchError(function (err) { return [ShellActions.setErrorMessage({ message: err.message, source: '' })]; })); })); });
        this.loadAgencyObjects$ = createEffect(function () { return _this.actions$.pipe(ofType(Lookups.loadAgencyObjects), mergeMap(function (action) { return _this.profileService.getAgencyObjects().pipe(mergeMap(function (response) {
            return [
                Lookups.updateAgencyObjects(response),
            ];
        }), catchError(function (err) { return [ShellActions.setErrorMessage({ message: err.message, source: '' })]; })); })); });
        this.loadUnions$ = createEffect(function () { return _this.actions$.pipe(ofType(Lookups.loadUnions), mergeMap(function (action) { return _this.profileService.getUnions().pipe(mergeMap(function (response) {
            return [
                Lookups.updateUnions(response),
            ];
        }), catchError(function (err) { return [ShellActions.setErrorMessage({ message: err.message, source: '' })]; })); })); });
        this.loadUnionObjects$ = createEffect(function () { return _this.actions$.pipe(ofType(Lookups.loadUnionObjects), mergeMap(function (action) { return _this.profileService.getUnionObjects().pipe(mergeMap(function (response) {
            return [
                Lookups.updateUnionObjects(response),
            ];
        }), catchError(function (err) { return [ShellActions.setErrorMessage({ message: err.message, source: '' })]; })); })); });
        this.loadOlmrNumbers$ = createEffect(function () { return _this.actions$.pipe(ofType(Lookups.loadOlmrNumbers), mergeMap(function (action) { return _this.profileService.getOlmrNumbers().pipe(mergeMap(function (response) {
            return [
                Lookups.updateOlmrNumbers(response),
            ];
        }), catchError(function (err) { return [ShellActions.setErrorMessage({ message: err.message, source: '' })]; })); })); });
        this.loadBusCodes$ = createEffect(function () { return _this.actions$.pipe(ofType(Lookups.loadBusCodes), mergeMap(function (action) { return _this.profileService.getBusCodes().pipe(mergeMap(function (response) {
            return [
                Lookups.updateBusCodes(response),
            ];
        }), catchError(function (err) { return [ShellActions.setErrorMessage({ message: err.message, source: '' })]; })); })); });
        this.loadBusCodeObjects$ = createEffect(function () { return _this.actions$.pipe(ofType(Lookups.loadBusCodeObjects), mergeMap(function (action) { return _this.profileService.getBusCodeObjects().pipe(mergeMap(function (response) {
            return [
                Lookups.updateBusCodeObjects(response),
            ];
        }), catchError(function (err) { return [ShellActions.setErrorMessage({ message: err.message, source: '' })]; })); })); });
        this.loadCpdfCodeObjects$ = createEffect(function () { return _this.actions$.pipe(ofType(Lookups.loadCpdfCodeObjects), mergeMap(function (action) { return _this.profileService.getCpdfCodeObjects().pipe(mergeMap(function (response) {
            return [
                Lookups.updateCpdfCodeObjects(response),
            ];
        }), catchError(function (err) { return [ShellActions.setErrorMessage({ message: err.message, source: '' })]; })); })); });
        this.loadAffiliationObjects$ = createEffect(function () { return _this.actions$.pipe(ofType(Lookups.loadAffiliationObjects), mergeMap(function (action) { return _this.profileService.getAffiliationObjects().pipe(mergeMap(function (response) {
            return [
                Lookups.updateAffiliationObjects(response),
            ];
        }), catchError(function (err) { return [ShellActions.setErrorMessage({ message: err.message, source: '' })]; })); })); });
    }
    LookupEffects.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LookupEffects_Factory() { return new LookupEffects(i0.ɵɵinject(i1.Actions), i0.ɵɵinject(i2.ProfileService), i0.ɵɵinject(i3.Store)); }, token: LookupEffects, providedIn: "root" });
    return LookupEffects;
}());
export { LookupEffects };
